// Dependencies
import styled from 'styled-components';

const ModalStyles = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  pointer-events: ${(props) => (props?.open ? 'initial' : 'none')};
  width: 100%;
  height: 100%;
  cursor: initial;

  .modal-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 2rem var(--grid-mobile-gutter);
    opacity: 0;
    transition: opacity 0.4s;

    &::after {
      content: '';
      position: absolute;
      z-index: 1;
      display: block;
      width: 100%;
      height: 100%;
      z-index: 999;
      background-color: rgba(0, 0, 0, 0.5);
    }

    .modal {
      position: relative;
      z-index: 1000;
      width: 100%;
      max-height: 70vh;
      overflow: auto;
      padding: 0 2rem 2.5rem 2rem;
      text-align: left;
      background-color: var(--color-white);

      .modal-header {
        display: flex;
        justify-content: space-between;
        padding: 2rem 0 3rem;

        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
          margin-bottom: 0;
          font-weight: var(--font-weight-medium);
          max-width: 85%;
        }

        .close {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 3rem;
          height: 3rem;
          padding: 0.313rem;
          margin: -0.4rem -1rem 0 0;

          .icon {
            width: 1.1rem;
            transition: fill 0.4s;
          }

          &:hover,
          &:focus {
            .icon {
              fill: #000;
            }
          }
        }

        & > div {
          width: 100%;
        }
      }
    }
  }

  &.fade-in .modal-wrapper {
    opacity: 1;
  }

  @media (min-width: 768px) {
    .modal-wrapper {
      padding: 4rem var(--grid-desktop-gutter);

      .modal {
        max-width: 45rem;
        max-height: 70vh;
        padding: 0 4rem 3.5rem 3rem;
      }
    }
  }

  @media (min-width: 992px) {
    .modal-wrapper .modal {
      max-width: 55rem;
    }
  }
`;

export default ModalStyles;
